import {Jobstack} from './Jobstack';
import CustomerDesktopBase from '../CustomerDesktopBase';

export class CustomerDesktopJobstack extends Jobstack {

    /**
     * Changes for Customer desktop Jobstack
     * https://swipejobs.atlassian.net/wiki/spaces/PROD/pages/622133280/Customer+Desktop+TBI
     */

    constructor() {
        super();
        this.setJobstackCustomerColors();
        this.setJobstackCustomerTypographys();
    };

    private setJobstackCustomerColors (): void {
        this.colors.general.primaryColor = this.colorPalette.orange;
        this.colors.general.secondaryColor = this.colorPalette.grayDarkSecondary;
        this.colors.general.tertiaryColor = this.colorPalette.blackLight;

        this.colors.hover.primaryHoverColor = this.colorPalette.orangeDark;

        this.colors.text.secondaryTextColor = this.colorPalette.blueDeep;

        this.colors.title.defaultColor = this.colorPalette.blueDeep;

        this.setDeprecatedJobstackCustomerColors();
    };

    private setDeprecatedJobstackCustomerColors (): void {
        /** @deprecated since version 0.2.*, use hover.primaryHoverColor */
        this.colors.general.primaryHoverColor = this.colorPalette.blueDark;
        /** @deprecated since version 0.2.*, use hover.secondaryHoverColor */
        this.colors.general.secondaryHoverColor = this.colorPalette.grayLight;

        /** @deprecated since version 0.2.*, use text.secondaryTextColor */
        this.colors.general.secondaryTextColor = this.colorPalette.blueDeep;
    };

    private setJobstackCustomerTypographys (): void {
        this.typography.button.text.textTransform = 'uppercase';
        this.typography.font.title.textTransform = 'uppercase';
    };
}

const customerDesktopJobstackTheme = CustomerDesktopBase.setShareStyles(new CustomerDesktopJobstack());
export default customerDesktopJobstackTheme;


// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Jobstack/customer-desktop.ts